import React from "react";
import {
  Search,
  useSearch,
  useResults,
  Results as ReactifyResults,
  Suggestions,
} from "@usereactify/search";
import { SearchInput } from "./searchInput";
import { ResultCardProduct } from "@app/scripts/reactify/results/ResultCardProduct";
import { SuggestedSearches } from "./SuggestedSearches";

export const InstantSearch: React.FC = () => {
  const { searchTerm, submitSearchTerm } = useSearch();
  const { resultStats } = useResults();

  return (
    <>
      <Search render={SearchInput} />
      {searchTerm && resultStats?.displayedResults && resultStats?.displayedResults > 0 ? (
        <div className="instant-search__results-submit flex justify-between align-center">
          <p>Showing {resultStats?.displayedResults} for '{searchTerm}'</p>

          <div className="flex justify-center">
            <button onClick={() => submitSearchTerm(searchTerm)}>
              View All
            </button>
          </div>
        </div>
      ) : null}

      {searchTerm && (
        <div className="instant-search__results-container flex flex-col gap-4">
          {/* <Suggestions
            field="title"
            render={(props) => SuggestedSearches(props)}
          /> */}
          <ReactifyResults
            pageSize={24}
            listStyle={{}}
            listClassName="instant-search__results gap-3"
            renderResultCardProduct={(props) => (
              <ResultCardProduct instantSearch={true} {...props} />
            )}
          />
        </div>
      )}
    </>
  );
};
